import { useEffect, useState } from 'react';
import { unformatIncome, validateIncomeSchema } from 'helpers/money.helper';
import { validateTotalAnnualIncome } from 'helpers/oneClickApp.helpers';
import { useDispatch, useSelector } from 'react-redux';
import { patchUser } from 'actions/userInfo.actions';
import { getAccountMixContainer } from 'actions/dashboard.actions';
import { resetCreditInfo } from 'actions/creditInfo.actions';

const useAccountMixSummary = () => {
  const [income, setIncome] = useState();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { selectedBureau, annualIncome } = useSelector(state => ({
    selectedBureau: state?.score1b3bFactorDial?.bureau?.selectedBureau,
    annualIncome: state?.userInfo?.userInfo?.annualIncome,
  }));

  const onChangeTotalAnnualIncome = value => {
    if (/^\d*$/.test(unformatIncome(value))) {
      var totalAnnualIncome = validateIncomeSchema(value);
      setIncome({
        totalAnnualIncome: totalAnnualIncome,
        totalAnnualIncomeError: validateTotalAnnualIncome(
          unformatIncome(totalAnnualIncome?.label),
        ),
      });
    } else {
      let totalAnnualIncome = '';
      setIncome({
        totalAnnualIncome: totalAnnualIncome,
        totalAnnualIncomeError: validateTotalAnnualIncome(totalAnnualIncome),
      });
    }
  };

  const dispatch = useDispatch();
  const onSaveHandle = e => {
    if (loading) return;
    setLoading(true);
    e.preventDefault();
    dispatch(
      patchUser({
        annualIncome: income?.totalAnnualIncome?.value,
        incomeSource: 'PROFILE',
      }),
    )
      .then(() => {
        dispatch(resetCreditInfo());
        dispatch(getAccountMixContainer({ bureau: selectedBureau })).then(
          () => {
            setIsOpenModal(false);
            setLoading(false);
          },
        );
      })
      .catch(() => setLoading(false));
  };

  const handleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  useEffect(() => {
    if (annualIncome) {
      setIncome({
        totalAnnualIncome: { label: annualIncome },
        totalAnnualIncomeError: validateTotalAnnualIncome(annualIncome),
      });
    }
  }, [annualIncome]);

  return {
    income,
    isOpenModal,
    loading,
    onChangeTotalAnnualIncome,
    onSaveHandle,
    handleModal,
  };
};

export default useAccountMixSummary;
